import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

export const CustomCell = ({
  rowSpan,
  rowId,
  rowIndex,
  colId,
  selectCellData,
  format,
  typeComponent,
  compareVal,
}) => {
  const val = useSelector(
    selectCellData(compareVal, typeComponent, rowId, rowIndex, colId),
  )

  return (
    <td
      rowSpan={rowSpan}
      style={{
        textAlign: ['typeGroup', 'vsicId'].includes(colId) ? 'left' : 'right',
      }}
    >
      {format(val)}
    </td>
  )
}

CustomCell.propTypes = {
  colId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowSpan: PropTypes.number,
  selectCellData: PropTypes.func,
  format: PropTypes.func,
}

CustomCell.defaultProps = {
  rowSpan: 1,
  selectCellData: () => {},
  format: () => {},
}
